import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const bonusCampaignApi = createApi({
  reducerPath: "bonusCampaignApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/bonusCampaign" }),
  tagTypes: ["BonusCampaign", "Transaction"],
  endpoints: (builder) => ({
    getBonusCampaign: builder.query({
      query: (params) => "?" + new URLSearchParams(params),
      providesTags: ["BonusCampaign"],
    }),
    createBonusCampaign: builder.mutation({
      query: ({ body }) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: ["BonusCampaign"],
    }),
    updateBonusCampaign: builder.mutation({
      query: ({ id, body }) => ({
        url: id,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["BonusCampaign"],
    }),
    getDisbursements: builder.query({
      query: (params) => "disbursements?" + new URLSearchParams(params),
      providesTags: ["Transaction"],
    }),
    payBonus: builder.mutation({
      query: ({ body }) => ({
        url: "pay",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Transaction"],
    }),
    getCampaignReport: builder.query({
      query: (params) => "report?" + new URLSearchParams(params),
    })
  }),
})

export const {
  useGetBonusCampaignQuery,
  useCreateBonusCampaignMutation,
  useUpdateBonusCampaignMutation,
  useLazyGetDisbursementsQuery,
  usePayBonusMutation,
  useLazyGetCampaignReportQuery,
} = bonusCampaignApi;